module.exports = __webpack_public_path__ + "img/contact1.32a9893c.jpg";